export default __webpack_public_path__ + "images/5U.f7d8dcf.png";